module.exports = __webpack_public_path__ + "img/arrow_right.a51fed84.svg";